import axios from '@/utils/request'

export default {
    getUserTotalReport: data => axios({ url: '/api/report/userTotalReport', method: 'POST', data }),//报表-用户概览
    getUserTotalReportPaymentTime: data => axios({ url: '/api/report/userTotalReportPaymentTime', method: 'POST', data }),//报表-用户概览(付款时间维度)
    getUserTotalReportManage: data => axios({ url: '/api/report/userTotalReportManage', method: 'POST', data }),//报表-用户概览(创建时间维度)
    getUserDetailReport: data => axios({ url: '/api/report/userDetailReport', method: 'POST', data }),//报表-用户明细
    getUserInfoSelect: data => axios({ url: '/api/store/userInfoSelect', method: 'POST', data }),//后台--角色用户信息下拉选择
}